import gql from 'not-graphql-tag';
import {
  GetRequestInput,
  GetRequestOutput,
  GetRequestsInput,
  GetRequestsOutput,
  IsEligibleForConsultationInput,
  IsEligibleForConsultationOutput,
  QueryGetRequestArgs,
  QueryGetRequestsArgs,
  QueryIsEligibleForConsultationArgs,
} from '../../__generated__/pgeplus-types';

import { useApolloClient } from '@apollo/react-hooks';

const getConsultationRequestsQuery = gql`
  query GetRequests($input: GetRequestsInput!) {
    getRequests(input: $input) {
      requests {
        id
        accountId
        premiseId
        requestNo
        category
        status
      }
    }
  }
`;
const isEligibleforconsultation = gql`
  query IsEligibleForConsultation($input: IsEligibleForConsultationInput!) {
    isEligibleForConsultation(input: $input) {
      isEligible
      ineligibilityReasons {
        code
        message
      }
    }
  }
`;

export const getConsultationRequestQuery = gql`
  query getRequestDetail($input: GetRequestInput!) {
    getRequest(input: $input) {
      request {
        visibleComments
        workComments
        accountId
        assignedUserName
        assignedToOperationsUserId
        category
        id
        isOpened
        language
        requestNo
        status
        accountContact {
          emailAddress
          firstName
          lastName
          middleName
          phoneNumber
          address {
            addressLine1
            city
            postal
            state
          }
        }
        providedDetails {
          ... on EVConsultProvidedDetails {
            evDiscussionTopics: discussionTopics
            otherDiscussion
          }
          preferredTime
          preferredDay
          ... on HVConsultProvidedDetails {
            hvDiscussionTopics: discussionTopics
            otherDiscussion
            consultationService
          }
        }
        operatorProvidedDetails {
          customerIntentToUsePGEPlus
          hasMainElectricalPanelConcerns
          hasRecommendedInstallReferral
          hasRecommendedMainElectricalPanelUpgrade
          recommendedEnergyTrustRebates
          recommendedInstallerInformation {
            email
            name
            phone
          }
          ... on EVConsultOperatorProvidedDetails {
            customerIntentToUsePGEPlus
            hasMainElectricalPanelConcerns
            hasRecommendedInstallReferral
            hasRecommendedMainElectricalPanelUpgrade
            recommendedEnergyTrustRebates
          }
          ... on HVConsultOperatorProvidedDetails {
            customerIntentToUsePGEPlus
            hasMainElectricalPanelConcerns
            hasRecommendedInstallReferral
            hasRecommendedMainElectricalPanelUpgrade
            recommendedEnergyTrustRebates
          }
        }
        userContactDetails {
          email
          firstName
          id
          lastName
          middleName
          phone
          relationship
          requestId
        }
        contactAttempts {
          contactDate
          contactMethod
          updatedAt
        }
      }
    }
  }
`;
const useGetConsultationRequests = () => {
  const apolloClient = useApolloClient();

  const getConsultationRequests = async (
    input: GetRequestsInput,
    query = getConsultationRequestsQuery,
  ) => {
    return apolloClient.query<
      { getRequests: GetRequestsOutput },
      QueryGetRequestsArgs
    >({
      query,
      variables: { input },
      context: { pgePlus: true },
      fetchPolicy: 'no-cache',
    });
  };

  const getConsultationRequest = async (
    input: GetRequestInput,
    query = getConsultationRequestQuery,
  ) => {
    return apolloClient.query<
      { getRequest: GetRequestOutput },
      QueryGetRequestArgs
    >({
      query,
      variables: { input },
      context: { pgePlus: true },
      fetchPolicy: 'no-cache',
    });
  };

  const getIsEligibleforconsultation = async (
    input: IsEligibleForConsultationInput,
    query = isEligibleforconsultation,
  ) => {
    return apolloClient.query<
      { isEligibleForConsultation: IsEligibleForConsultationOutput },
      QueryIsEligibleForConsultationArgs
    >({
      query,
      variables: { input },
      context: { pgePlus: true },
      fetchPolicy: 'no-cache',
    });
  };

  return {
    getConsultationRequest,
    getConsultationRequests, //Query
    getIsEligibleforconsultation,
  };
};

export default useGetConsultationRequests;
